<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div>
            <el-button type="primary" @click="excute" :disabled="!btn.exc">{{$t('getapi[440]')}}</el-button>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_outchangeinvoiceno',
        data() {
            return {
                btn:{
                    exc:true
                }
            };
        },
        mounted: function () {
            let that = this;
            that.authority()
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12577]"),this.$t("getapi[6614]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            excute(){
                let that = this;
                that.$confirm(this.$t('getapi[13017]'), this.$t('getapi[194]'), {//'确定用开票系统发票号更新销售发票号?'
                    confirmButtonText: this.$t('getapi[1146]'),
                    cancelButtonText: this.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                        }
                        that.btn.exc = false
                        that.$http.urlpost('Finance/SalInvoiceManage/OutChangeInvoiceNo', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            }
                            that.btn.exc = true
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('getapi[8574]')
                        });
                    });
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
